import { IO } from "@al/base-lib";

let io: IO | null = null;

function setIO(ioInstance: IO): void {
  io = ioInstance;
}

function getIO(): IO {
  if (!io) {
    throw new Error("IO未初始化");
  }
  return io as IO;
}

export { getIO, setIO };
